export const PROMO_CARD_WIDTH = 564;
export const PROMO_CARD_MOBILE_WIDTH = 270;

export const PROMO_CARD_HEIGHT = 290;
export const PROMO_CARD_MOBILE_HEIGHT = 300;
